import system from './request/api'
export default {
    install(Vue){
        Vue.prototype.$api = this
    },
    system
}
